import { render, staticRenderFns } from "./check-icon.vue?vue&type=template&id=37153832&"
import script from "./check-icon.vue?vue&type=script&lang=js&"
export * from "./check-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports